import React, { Component } from "react"
import { Modal } from "antd"
import MasterFormVideo from "../multisteps/formMultistepVideos"

class VideoModal extends Component {
	render() {
		return (
			<Modal
				title='Video Modal'
				visible={this.props.isOpen}
				onOk={this.props.onCloseModal}
				onCancel={this.props.onCloseModal}
			>
			
				<MasterFormVideo />
			</Modal>
		)
	}
}

export default VideoModal
